<template>
  <div class="flex sharing-v">
    <Header />
    <Step />
    <div v-if="!needUpdate" class="row-item flex sharing-v">
      <a-form id="accountLoginForm" :form="formPhone" class="phone-form" @submit="confirmSubmit">
        <a-form-item label="手机号">
          <a-input
            v-decorator="[
              'phone',
              {
                initialValue: userInfo.mobile,
                rules: [
                { required: true, message: '请输入手机号' },
              ]}
            ]"
            disabled
            placeholder="请输入手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="验证码">
          <a-input-search
            v-decorator="[
              'code',
              {rules: [
                { required: true, message: '请输入验证码' },
              ]}
            ]"
            placeholder="请输入验证码"
            @search="getCode"
            size="default"
          >
            <a-button type="primary" slot="enterButton" :disabled="codeDisabled">{{txt}}</a-button>
             
          </a-input-search>
        
        </a-form-item>
        <!-- <div class="form-item flex sharing-v">
          <a href="javascript:void(0)" style="color:#1890FF" @click="toggleUpdatePhone">修改手机号</a>
        </div>-->
        <a-form-item class="text-center" style="margin-top:20px">
          <a href="/photo"><a-button type="detault" style="margin-right:20px;">上一步</a-button></a>
          <a-button type="primary" html-type="submit">下一步</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div v-else class="row-item flex sharing-v">
      <a-form
        id="accountLoginForm"
        :form="formPhoneUpdate"
        class="phone-form"
        @submit="updateSubmit"
      >
        <a-form-item label="原手机号">
          <a-input
            v-decorator="[
              'userName',
              {rules: [
                { required: true, message: '请输入原手机号' },
                { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的原手机号' },
              ]}
            ]"
            placeholder="请输入原手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="新手机号">
          <a-input
            v-decorator="[
              'userName',
              {rules: [
                { required: true, message: '请输入新手机号' },
                { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的新手机号' },
              ]}
            ]"
            placeholder="请输入新手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="验证码">
          <a-input-search
            v-decorator="[
              'userName',
              {rules: [
                { required: true, message: '请输入验证码' },
              ]}
            ]"
            placeholder="请输入验证码"
            @search="onSearch"
            size="default"
          >
            <a-button type="primary" slot="enterButton" >发送验证码</a-button>
          </a-input-search>
        </a-form-item>
        <div class="form-item flex sharing-v">
          <a href="javascript:void(0)" style="color:#1890FF" @click="toggleUpdatePhone">返回，不改了</a>
        </div>
        <a-form-item class="text-center" style="margin-top:20px">
          <a href="/photo"><a-button type="detault" inline-block style="margin-right:20px;">上一步</a-button></a>
          <a-button type="primary" html-type="submit" inline-block class="login-form-button">下一步</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import Step from "../components/common/step";
// import Code from "../components/common/code.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");
export default {
  name: "Login",
  components: {
    Header,
    Step
  },
  data() {
    return {
      userInfo: {},
      codeDisabled:false,
      txt:"发送验证码",
      time: 30,
      needUpdate: false,
      formPhone: this.$form.createForm(this),
      formPhoneUpdate: this.$form.createForm(this)
    };
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.userInfo = userInfo;
  },
  methods: {
    ...mapActions(["getPhoneCode", "validPhoneCode", "updateStudentAction"]),
    getCode() {
      this.minusTime()
      
      this.getPhoneCode(this.userInfo.mobile).then(res => {
        console.log(res);
      });
    },
     minusTime() {
      this.txt = `重新发送(${this.time}s)`;
      this.codeDisabled = true;
      let interval = setInterval(() => {
        this.time -= 1;
        this.txt = `重新发送(${this.time}s)`;
        if (this.time <= 0) {
          clearInterval(interval);
          this.txt = `获取验证码`;
          this.codeDisabled = false;
          this.time = 30;
        }
      }, 1000);
    },
    confirmSubmit(e) {
      e.preventDefault();
      this.formPhone.validateFields((err, values) => {
        if (!err) {
          console.log(values);
          this.validPhoneCode(values).then(res => {
            console.log(res);
             
            this.applyStatusJudge(res.data)

            let vs = {}
            let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
            vs.enrollInfoId = userInfo.enrollInfoId;
            vs.examCode = userInfo.examCode;
            vs.updateType = 5;
            vs.mobile = this.userInfo.mobile;

            let formData = new FormData();
            // fields 是表單內容，將它 append 到 formData
            Object.keys(vs).map(item => {
              formData.append(item, vs[item]);
            });
            this.updateStudentAction(formData)
          });
        }
      });
    },
    updateSubmit(e) {
      e.preventDefault();
      this.formPhoneUpdate.validateFields((err, values) => {
        if (!err) {
          console.log(values);
        }
      });
    },
    toggleUpdatePhone() {
      this.needUpdate = !this.needUpdate;
    },
    applyStatusJudge(data) {
      if (data.status == 2000) {
        this.$router.push("/infomation");
      } else {
        this.$warning({
          title: data.message,
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() {
            console.log("OK");
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.row-item {
  margin-top: 15px;
  align-items: center;
}
.form-title {
  margin-bottom: 15px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.form-item {
  width: 300px;
  margin-top: 20px;
  align-items: flex-start;
}
.next-box {
  margin-top: 30px;
  justify-content: center;
}
.avatar-box {
  margin-top: 50px;
}
</style>